import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";

export default function AnnouncementBar() {
  const [bar, setBar] = useState(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    http.get("/announcements?page=all").then((r) => {
      if (r.data?.length) setBar(r.data[0]);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!bar?.rotating || !bar?.messages?.length) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % bar.messages.length), bar.interval || 4000);
    return () => clearInterval(t);
  }, [bar]);

  if (!bar || !bar.messages?.length) return null;
  const msg = bar.messages[idx % bar.messages.length];
  const variant = bar.variant || "cobalt";
  const style = variant === "cobalt" ? { background: "var(--ss-accent)", color: "#fff" }
    : variant === "white" ? { background: "#f4f4f5", color: "#09090b" }
    : { background: "#09090b", color: "#f4f4f5" };

  return (
    <div style={style} className="relative text-center" data-testid="announcement-bar">
      <div className="py-2 px-10 text-[11px] sm:text-xs font-semibold uppercase tracking-widest truncate">
        {msg.link ? <Link to={msg.link} className="hover:underline">{msg.text}</Link> : msg.text}
      </div>
    </div>
  );
}
